var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 2.6V12.2C4.2 12.6243 4.36857 13.0313 4.66863 13.3314C4.96868 13.6314 5.37565 13.8 5.8 13.8H12.2C12.6243 13.8 13.0313 13.6314 13.3314 13.3314C13.6314 13.0313 13.8 12.6243 13.8 12.2V5.1936C13.8 4.98045 13.7574 4.76945 13.6747 4.573C13.5919 4.37654 13.4708 4.19859 13.3184 4.0496L10.6664 1.456C10.3675 1.16373 9.96605 1.00005 9.548 1H5.8C5.37565 1 4.96868 1.16857 4.66863 1.46863C4.36857 1.76869 4.2 2.17565 4.2 2.6V2.6Z",
    stroke: "#D3FF9A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 13.8V15.4C10.6 15.8243 10.4314 16.2313 10.1314 16.5314C9.83131 16.8314 9.42435 17 9 17H2.6C2.17565 17 1.76869 16.8314 1.46863 16.5314C1.16857 16.2313 1 15.8243 1 15.4V6.6C1 6.17565 1.16857 5.76869 1.46863 5.46863C1.76869 5.16857 2.17565 5 2.6 5H4.2",
    stroke: "#D3FF9A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLinkIcon);
export default __webpack_public_path__ + "static/media/copy-link-icon.3b7d43109b43a52723b16278b8c470ed.svg";
export { ForwardRef as ReactComponent };